const rootEnvContent = `


`

export default rootEnvContent;